
import orderUtil from "../Utils/orderUtil.js";
const Css = {
  ControlBox(w, isMouseDown){
    let cursor = isMouseDown ? "pointer" : "default";
    return {
      position: "relative",
      width: w + "px",
      height: orderUtil.controlBoxHeight + "px",
      float: "right",
      backgroundColor: "#191A1B",
      cursor,
    }
  }
}

export default Css;